/* eslint-disable no-empty-pattern */
import debounce from 'lodash/debounce';

import { MODULE_NAME } from './const';
import { SET_SELECTED_PROJECT_ID, SET_LOADING_WORKFLOWS_FLAG } from './mutations';
import state from './state';
import StoreModuleService from '../StoreModuleService';
import { updateProject, createProject, getProjectData } from '../projects/actions';
import { getWorkflows } from '../workflows/actions';
import router from '@/router';
import { APP_MAIN_LANDING_PAGE } from '@/router/router.const';
import { PROJECTS_SHARED_WITH_ME_VIRTUAL_ID, VIRTUAL_PROJECT_IDS } from '@/utils/projects.const';
const buildSelectedProjectActionObject = (action) => StoreModuleService.buildActionObject(MODULE_NAME, action);

// actions declarations
export const selectProjectId = buildSelectedProjectActionObject('selectProjectId');
export const getFlowsForSelectedProject = buildSelectedProjectActionObject('getFlowsForSelectedProject');
export const createAndSelectProject = buildSelectedProjectActionObject('createAndSelectProject');
export const updateSelectedProject = buildSelectedProjectActionObject('updateSelectedProject');

const actions = {
	...StoreModuleService.createDefaultActions(),
	async [createAndSelectProject.action]({ dispatch }, payload) {
		const { project } = payload;

		// we need the returned project to know which projectId to select
		const newProject = await dispatch(createProject.fullPath, { project }, { root: true });
		dispatch(selectProjectId.action, { id: newProject.id });
	},
	[selectProjectId.action]({ commit, dispatch }, payload) {
		const { id } = payload;
		commit(SET_SELECTED_PROJECT_ID, id);
		const currentRoute = router.currentRoute;
		if (isMainAppLayoutChild(currentRoute) && currentRoute.params.spaceId !== id) {
			router.push({ params: { ...currentRoute.params, spaceId: id } });
		}
		if (id && !isNaN(id)) {
			// so we only get real projects ids.
			// Dont add await here, and make it async, as SET_SELECTED_PROJECT_ID must happen.
			dispatch(getProjectData.fullPath, { id }, { root: true });
		}
	},
	async [getFlowsForSelectedProject.action]({ dispatch, commit }, payload) {
		const { page, filterBy = {}, keepResults, autoPaginate } = payload || {};
		commit(SET_LOADING_WORKFLOWS_FLAG, true);
		try {
			if (state.selectedProjectId && !VIRTUAL_PROJECT_IDS.includes(state.selectedProjectId)) {
				filterBy.project = state.selectedProjectId;
			}
			if (PROJECTS_SHARED_WITH_ME_VIRTUAL_ID === state.selectedProjectId) {
				filterBy.shared_with_me = true; // if we set false we actually request to exclude the projects shared with me
			}
			const res = await dispatch(getWorkflows.fullPath, { page, filterBy, autoPaginate }, { root: true });
			const data = autoPaginate ? { results: res, hasNexPage: false, count: res.length } : res;
			data['workflows'] = data['results'].map((workflow) => workflow.id);
			if (!keepResults) {
				delete data['results']; // We don't want to return the whole workflows objects, just the modified ^
			}
			return data;
		} finally {
			commit(SET_LOADING_WORKFLOWS_FLAG, false);
		}
	},
	[updateSelectedProject.action]: debounce(({ dispatch }, payload) => {
		const { project } = payload;
		dispatch(updateProject.fullPath, { project }, { root: true });
	}, 600),
};

export default actions;
// HELPERS
const isRouteOrChildOfRoute = (currentRoute, routeName) =>
	currentRoute.name === routeName || currentRoute.matched.some((r) => routeName === r.name);
const isMainAppLayoutChild = (route) => isRouteOrChildOfRoute(route, APP_MAIN_LANDING_PAGE); //These functions couldnt be moved to helpers.js because of circular dependency
